/**
 * Create icon SVG element
 * @param {string} iconType - Type of icon
 * @param {number} size - Icon size
 * @returns {string} SVG icon HTML
 */
export function createIcon(iconType, size = 20, iconColor) {
    const iconMap = {
        feedaura: createFeedauraIcon(size, iconColor),
        heart: createHeartIcon(size),
        close: createCloseIcon(size),
        success: createSuccessIcon(size),
    };

    return iconMap[iconType] || iconMap.feedaura;
}

/**
 * Create Feedaura brand icon
 * @param {number} size - Icon size
 * @returns {string} SVG HTML
 */
function createFeedauraIcon(size, iconColor) {
    return `
    <svg width="${size}" height="${size}" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M31.5 7.23333C30.3333 7.23333 29.1667 7 28 7C26.8333 7 25.6667 7.23333 24.5 7.23333" stroke="${iconColor}" stroke-width="3.05455" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M45.0333 15.8666C43.6416 14.0083 41.9916 12.3583 40.1333 10.9666" stroke="${iconColor}" stroke-width="3.05455" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M48.7666 31.5C48.9999 30.3333 48.9999 29.1667 48.9999 28C48.9999 26.8333 48.7666 25.6667 48.7666 24.5" stroke="${iconColor}" stroke-width="3.05455" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M40.1333 45.0333C41.9916 43.6416 43.6416 41.9916 45.0333 40.1333" stroke="${iconColor}" stroke-width="3.05455" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M24.5 48.7666C25.6667 48.9999 26.8333 48.9999 28 48.9999C29.1667 48.9999 30.3333 48.7666 31.5 48.7666" stroke="${iconColor}" stroke-width="3.05455" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M8.1665 40.8333L4.6665 51.3333L15.1665 47.8333" stroke="${iconColor}" stroke-width="3.05455" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M7.23333 24.5C7.23333 25.6667 7 26.8333 7 28C7 29.1667 7.23333 30.3333 7.23333 31.5" stroke="${iconColor}" stroke-width="3.05455" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M15.8668 10.9666C14.0085 12.3583 12.3585 14.0083 10.9668 15.8666" stroke="${iconColor}" stroke-width="3.05455" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M39.3133 28.0001H36.5076C36.0132 27.9991 35.532 28.16 35.1377 28.4583C34.7434 28.7566 34.4577 29.1758 34.3242 29.6519L31.6656 39.1096C31.6485 39.1684 31.6127 39.22 31.5638 39.2567C31.5148 39.2934 31.4553 39.3133 31.3941 39.3133C31.3329 39.3133 31.2733 39.2934 31.2244 39.2567C31.1754 39.22 31.1397 39.1684 31.1226 39.1096L24.8777 16.8906C24.8606 16.8319 24.8249 16.7803 24.7759 16.7436C24.7269 16.7069 24.6674 16.687 24.6062 16.687C24.545 16.687 24.4855 16.7069 24.4365 16.7436C24.3876 16.7803 24.3518 16.8319 24.3347 16.8906L21.6761 26.3484C21.5431 26.8226 21.2591 27.2405 20.8671 27.5386C20.475 27.8367 19.9965 27.9987 19.504 28.0001H16.687" stroke="${iconColor}" stroke-width="3.05455" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `;
}

/**
 * Create heart icon
 * @param {number} size - Icon size
 * @returns {string} SVG HTML
 */
function createHeartIcon(size) {
    return `
    <svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.61C2.1283 5.6417 1.5487 7.04097 1.5487 8.5C1.5487 9.95903 2.1283 11.3583 3.16 12.39L12 21.23L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.06211 22.0329 6.39467C21.7563 5.72723 21.351 5.1208 20.84 4.61V4.61Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  `;
}

/**
 * Create close icon
 * @param {number} size - Icon size
 * @returns {string} SVG HTML
 */
function createCloseIcon(size) {
    return `
    <svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  `;
}

/**
 * Create success checkmark icon
 * @param {number} size - Icon size
 * @returns {string} SVG HTML
 */
function createSuccessIcon(size) {
    return `
    <svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  `;
}
